import { __decorate } from "tslib";
import { customElement } from "@microsoft/fast-element";
import { ContentCard } from "./content-card";
import { ContentCardTemplate as template } from "./content-card.template";
import { ContentCardStyles as styles } from "./content-card.styles";
/**
 * @public
 */
let MsftContentCard = class MsftContentCard extends ContentCard {
};
MsftContentCard = __decorate([
    customElement({
        name: "msft-content-card",
        template,
        styles,
        shadowOptions: {
            delegatesFocus: true,
        },
    })
], MsftContentCard);
export { MsftContentCard };
